class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryTrigger = this.querySelector('summary');

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );
        this.summaryTrigger.addEventListener('click', this.onSummaryClick.bind(this));
        this.summaryTrigger.setAttribute('role', 'button');
        this.summaryTrigger.setAttribute('aria-expanded', 'false');
    }

    onSummaryClick(event) {
        const isOpen = this.detailsContainer.hasAttribute('open');
        const trapFocusTarget = event.currentTarget.nextElementSibling;
        !isOpen ? this.open(trapFocusTarget) : this.close();
    }

    open(trapFocusTarget) {
        this.summaryTrigger.setAttribute('aria-expanded', 'true');
        this.detailsContainer.setAttribute('open', '');
        trapFocusTarget.focus();
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.summaryTrigger.setAttribute('aria-expanded', 'false');
        this.detailsContainer.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        this.summaryTrigger.focus();
    }
}

customElements.define('details-modal', DetailsModal);
